export { default } from './ChangePasswordStep2';
